"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityConversionToJSON = exports.CommunityConversionFromJSONTyped = exports.CommunityConversionFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CommunityConversionFromJSON(json) {
    return CommunityConversionFromJSONTyped(json, false);
}
exports.CommunityConversionFromJSON = CommunityConversionFromJSON;
function CommunityConversionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'user': json['user'],
        'conversionType': (0, _1.CommunityConversionTypeFromJSON)(json['conversionType']),
        'status': (0, _1.CommunityConversionStatusFromJSON)(json['status']),
        'amount': json['amount'],
        'creditedUsd': json['creditedUsd'],
        'appliedRate': json['appliedRate'],
        'transactionRef': !(0, runtime_1.exists)(json, 'transactionRef') ? undefined : json['transactionRef'],
        'metadata': !(0, runtime_1.exists)(json, 'metadata') ? undefined : (0, _1.CommunityConversionMetadataFromJSON)(json['metadata']),
        'reviewedBy': !(0, runtime_1.exists)(json, 'reviewedBy') ? undefined : json['reviewedBy'],
        'reviewNotes': !(0, runtime_1.exists)(json, 'reviewNotes') ? undefined : json['reviewNotes'],
    };
}
exports.CommunityConversionFromJSONTyped = CommunityConversionFromJSONTyped;
function CommunityConversionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'user': value.user,
        'conversionType': (0, _1.CommunityConversionTypeToJSON)(value.conversionType),
        'status': (0, _1.CommunityConversionStatusToJSON)(value.status),
        'amount': value.amount,
        'creditedUsd': value.creditedUsd,
        'appliedRate': value.appliedRate,
        'transactionRef': value.transactionRef,
        'metadata': (0, _1.CommunityConversionMetadataToJSON)(value.metadata),
        'reviewedBy': value.reviewedBy,
        'reviewNotes': value.reviewNotes,
    };
}
exports.CommunityConversionToJSON = CommunityConversionToJSON;
